<template>
    <cadastro-simples-list
        endpoint="tipo-solicitacao-matricula"
        rota-base="/admin/tipo-solicitacao-matricula"
        titulo="TIPOS DE SOLICITAÇÃO DE MATRÍCULA"
        titulo-singular="Tipo de Solicitação de Matrícula"
        :colunas-extras='[]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
